import { addClass, removeClass } from '../support/classes';

class ToggleTabs extends elementorModules.frontend.handlers.Base
{
    onInit()
    {
        super.onInit();

        const { $component } = this.elements;

        this.group = $component.getAttribute('data-group');

        const tabs = document.getElementsByClassName(this.group);

        if (tabs)
        {
            // Hide initial tabs.
            for (let i = 0, len = tabs.length; i < len; i++)
            {
                addClass(tabs[i], 'tab-content');

                if (i === 0)
                {
                    addClass(tabs[i], 'active');
                }
            }
        }

        this.Tabs = new Hogo.Tabs( $component, this.getOptions() );

    }

    getOptions()
    {
        return {
            onChange: this._handleOnChange
        };
    }

    _handleOnChange(tab, value)
    {
        // Mark all in group as not active
        let tabs = document.getElementsByClassName(this.props.group);

        if (tabs)
        {
            for (let i = 0, len = tabs.length; i < len; i++)
            {
                removeClass(tabs[i], 'active');
            }
        }


        // Mark current value ID as active
        let content = document.getElementById(value);

        if (content)
        {
            addClass(document.getElementById(value), 'active');
        }
    }

    getDefaultSettings()
    {
        return {
            selectors: {
                component: '[data-component="tabs"]',
            },
        };
    }

    getDefaultElements()
    {
        const selectors = this.getSettings( 'selectors' );

        const element = this.$element[0];

        return {
            $component: element.querySelector( selectors.component ),
        };
    }
}

export default ($scope) => {
    elementorFrontend.elementsHandler.addHandler(ToggleTabs, { $element: $scope });
};